import AppRequestsTab from './AppRequestsTab';
import ToolAccessTab from './ToolAccessTab';

/**
 * App requests and tool access, merged.
 *
 * They were two tabs of the same shape -- "things you have been granted" --
 * and each was thin enough that a whole tab for it made the bar longer without
 * making anything easier to find. Both keep their own heading and their own
 * empty state, so neither list can be mistaken for the other being empty.
 *
 * `buildAppEnabled` still gates the app-requests half: the flag hides that
 * feature org-wide, and merging tabs must not resurrect it.
 *
 * Connected apps used to sit here; a real account has ~40 of them, which buried
 * these two lists, so they have their own tab (ConnectedAppsTab).
 */
export default function AccessTab({ tools, userId, isMemberView, buildAppEnabled }) {
  return (
    <div className="profile-card-grid profile-access">
      <ToolAccessTab tools={tools} isMemberView={isMemberView} />
      {buildAppEnabled && <AppRequestsTab userId={userId} isMemberView={isMemberView} />}
    </div>
  );
}
